import Vue from "vue"
import Vuetify from "vuetify"
import "vuetify/dist/vuetify.min.css"

// Load default plugin values from app.config file overrided by storage
import config from "@/app.config"
import store from "@/store"

Vue.use(Vuetify)

/**
 * Get currently activated theme colors
 * @param {*} $ The current component
 * @returns The theme object
 */
export function getTheme($) {
  let name = $.$store.state.app.isThemeDark ? "dark" : "light"
  return $.$vuetify.theme.themes[name]
}

/**
 * Get assets from name or currently activated theme assets
 * @param {*} $ The current component
 * @param {*} name The theme name
 * @returns The assets object
 */
export function getAssets($, name = undefined) {
  if (!name) name = $.$store.state.app.isThemeDark ? "dark" : "light"
  return $.$appConfig.assets.img[name]
}

export default new Vuetify({
  theme: {
    ...config.plugins.vuetify.theme,
    dark: store.state.app.isThemeDark
  },
  breakpoint: {
    mobileBreakpoint: 'sm' // ou 'xs', 'md'
  }
})
